import styled from 'styled-components'

export const LoadingContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
    z-index: 1;
`
